<template>
    <div uk-slider="center: true; autoplay: true; autoplay-interval: 5000">
      <div class="uk-position-relative">
        <div class="uk-slider-container">
          <ul class="uk-slider-items uk-child-width-1-2 uk-child-width-1-3@m uk-grid">
            <li v-for="(item, index) in slideItems" :key="index">
              <div class="uk-cover-container">
                <canvas width="400" height="275"></canvas>
                <img :src="item.url" alt="" uk-cover>
              </div>
            </li>
          </ul>
        </div>
        <div class="uk-hidden@s uk-light">
          <a class="uk-position-center-left uk-position-small" href="#" uk-slidenav-previous
             uk-slider-item="previous"></a>
          <a class="uk-position-center-right uk-position-small" href="#" uk-slidenav-next uk-slider-item="next"></a>
        </div>
        <div class="uk-visible@s">
          <a class="uk-position-center-left-out uk-position-small" href="#" uk-slidenav-previous
             uk-slider-item="previous"></a>
          <a class="uk-position-center-right-out uk-position-small" href="#" uk-slidenav-next
             uk-slider-item="next"></a>
        </div>
      </div>
      <ul class="uk-slider-nav uk-dotnav uk-flex-center uk-margin"></ul>
    </div>
</template>

<script>
export default {
  name: 'PropertySectionTwo',
  props: ['slideItems']
}
</script>

<style scoped>
  .SectionOne {
    padding-top: 30px;
  }
</style>
